module.exports = __webpack_public_path__ + "media/images/webpage/errors/bg-500-0a56475e4d7cce50030208a3d45e0faf.webp";